import styled from "styled-components"

export const Wrapper = styled.div`
    background: var(--medGrey);
    width: 300px;
    height: 440px;
    border-radius: 20px;
    padding: 5px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    color: var(--white);

    h3 {
        margin: 10px 0 0 0;
    }

    p {
        margin: 5px 0;
    }

    p2 {
        margin: 5px 0;
    }
`
